import { createAction } from '@ngrx/store';
import { SemanticSearchTopic } from 'src/app/models';

export const semanticsearchtopics = createAction(
  'SEMANTICSEARCHTOPICS',
  (payload: SemanticSearchTopic) => ({ payload })
);
